<template>
  <WhiteTooltipMenu
    :shown="shown"
    :title="$t('pos_pending_changes_tooltip.title')"
    @close="$emit('close')"
    :width="400"
  >
    <div class="changes-type-block">
      <BaseTabSwitcher :tabs="uiTabs" v-model="change_status_filter" />
    </div>

    <div class="no-changes-block" v-if="!filteredChanges.length">
      <img src="/icons/panda_hello.svg" />
      <div class="gap-row-1xs">
        <div class="qrw-heading-xs bold v1-grey-10-color centrify">
          {{ $t("pos_pending_changes_tooltip.no_changes") }}
        </div>
        <div class="qrw-label-lg v1-grey-7-color centrify">
          {{ $t("pos_pending_changes_tooltip.no_changes_sub") }}
        </div>
      </div>
    </div>

    <div class="changes-list" v-else>
      <div class="qrw-label-sm bold v1-grey-7-color">
        {{ $t("pos_pending_changes_tooltip.type_added") }}
      </div>
      <BaseCheckbox
        class="qrw-heading-xs"
        v-for="change in changes"
        :key="change._id"
        v-model="batch_map[change._id]"
      >
        <template v-if="change.change_type == 'new_product'">
          {{ change.payload.name }} ({{ change.payload.category }})
          <!-- <span class="change-item-description">
          - {{ $t("poster_pending_changes.new_product_suffix") }}</span
        > -->
        </template>

        <template v-else-if="change.change_type == 'new_price_group'">
          {{ change.payload.price_group.name || "" }} ({{
            change.payload.product_name
          }})
          <!-- <span class="change-item-description">
          - {{ $t("poster_pending_changes.new_price_group_suffix") }}</span
        > -->
        </template>

        <template v-else-if="change.change_type == 'new_price_group_item'">
          {{ change.payload.price_group_item.name }} ({{
            change.payload.product_name
          }})
          <!-- <span class="change-item-description">
          - {{ $t("poster_pending_changes.new_price_group_item_suffix") }}</span
        > -->
        </template>

        <template v-else-if="change.change_type == 'remove_price_group'">
          {{ change.payload.price_group_name || "" }} ({{
            change.payload.product_name
          }})
          <!-- <span class="change-item-description">
          - {{ $t("poster_pending_changes.remove_price_group_suffix") }}</span
        > -->
        </template>
      </BaseCheckbox>
    </div>

    <div class="changes-actions" v-if="filteredChanges.length">
      <BaseButton
        variant="secondary"
        size="md"
        color="v1-grey-10"
        @click="selectAll"
      >
        {{ $t("pos_pending_changes_tooltip.btn_select_all") }}
      </BaseButton>
      <BaseDivider color="v1-grey-4" />
      <div class="gap-column-xs">
        <BaseButton
          variant="secondary"
          size="md"
          class="w-100"
          :disabled="busy"
          :busy="busy"
          color="orange-4"
          @click="ignoreChanges"
          v-if="change_status_filter == 'pending'"
        >
          {{ $t("poster_pending_changes.ignore_btn") }}
        </BaseButton>

        <BaseButton
          variant="primary"
          size="md"
          class="w-100"
          color="green-5"
          :disabled="busy"
          :busy="busy"
          bold
          @click="acceptChanges"
        >
          {{ $t("poster_pending_changes.accept_btn") }}
        </BaseButton>
      </div>
    </div>
  </WhiteTooltipMenu>
</template>

<script>
import PosterAPI from "@/api/poster";

export default {
  data() {
    return {
      change_status_filter: "pending",
      changes: [],
      batch_map: {},

      busy: false,

      changes_queue: [],
    };
  },
  props: {
    menu_id: String,
    shown: Boolean,
  },
  watch: {
    menu_id() {
      this.fetchChanges();
    },
    shown() {
      this.change_status_filter = 'pending';
      this.selectAll();
    }
  },
  methods: {
    fetchChanges() {
      PosterAPI.getPendingChanges(this.menu_id)
        .then((data) => {
          this.changes = data.changes;
          this.batch_map = {};

          this.selectAll();

          this.$emit("newChangesCountUpdated", this.changeCounters.pending);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectAll() {
      this.batch_map = {};

      for (const change of this.filteredChanges) {
        this.$set(this.batch_map, change._id, true);
      }
    },
    acceptChanges() {
      const sm = {};

      Object.entries(this.batch_map).forEach((e) => {
        sm[e[0]] = e[1] ? "accepted" : "denied";
      });

      this.sendChanges(sm);
    },
    ignoreChanges() {
      const sm = {};

      Object.entries(this.batch_map).forEach((e) => {
        sm[e[0]] = "ignored";
      });

      this.sendChanges(sm);
    },
    sendChanges(map) {
      this.busy = true;

      PosterAPI.batchPendingChanges(map).finally(() => {
        this.applyChanges(map);
        this.fetchChanges();
      });

      this.updatePosLists();
    },
    updatePosLists() {
      if (this.$store.getters.hasPosterIntegration) {
        this.$store.dispatch("poster/fetchProductsList");
      }
    },
    eatQueue() {
      if (!this.changes_queue.length) {
        this.busy = false;
        this.changes = [];
        return;
      }

      const change = this.changes_queue.shift();

      let promise;

      if (change.change_type == "new_product") {
        promise = this.$store.dispatch("menu/addProduct", change.payload);
      }

      if (change.change_type == "new_price_group") {
        promise = this.$store.dispatch(
          "menu/addPriceGroupToProduct",
          change.payload
        );
      }

      if (change.change_type == "remove_price_group") {
        promise = this.$store.dispatch(
          "menu/removePriceGroupFromProduct",
          change.payload
        );
      }

      if (change.change_type == "new_price_group_item") {
        promise = this.$store.dispatch(
          "menu/addPriceGroupItemToProduct",
          change.payload
        );
      }

      if (promise) {
        promise.finally(() => {
          this.eatQueue();
        });
      } else {
        this.eatQueue();
      }
    },
    applyChanges(map) {
      const accepted_ids = Object.entries(map)
        .filter((e) => {
          return e[1] == "accepted";
        })
        .map((e) => e[0]);

      this.changes_queue = this.changes.filter((c) =>
        accepted_ids.includes(c._id)
      );
      this.eatQueue();
    },
  },
  computed: {
    uiTabs() {
      return [
        {
          text: `${this.$t("pos_pending_changes_tooltip.tab_new")} (${
            this.changeCounters.pending
          })`,
          value: "pending",
        },
        {
          text: `${this.$t("pos_pending_changes_tooltip.tab_ignored")} (${
            this.changeCounters.ignored
          })`,
          value: "ignored",
        },
      ];
    },
    changeCounters() {
      const counters = {
        pending: 0,
        ignored: 0,
      };

      this.changes.forEach((c) => counters[c.status]++);

      return counters;
    },
    filteredChanges() {
      return this.changes.filter((c) => c.status == this.change_status_filter);
    },
  },
  mounted() {
    this.fetchChanges();
  },
};
</script>

<style scoped>
.changes-type-block {
  display: flex;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
}

.changes-actions {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 16px;
  flex-direction: column;
  row-gap: 8px;
  background: var(--v1-grey-2-color);
}

.no-changes-block {
  padding: 40px 16px;
  display: flex;
  flex-direction: column;

  row-gap: 16px;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.no-changes-block img {
  display: block;
  width: 150px;
  height: 150px;
  max-height: 150px;
  min-width: 150px;
}

.centrify {
  text-align: center;
}

.changes-list {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  max-height: 450px;
  overflow-y: auto;
}

.change-item-description {
  color: var(--v1-grey-7-color);
}
</style>